import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { NoAuthGuard } from './core/guards/no-auth.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.module').then(m=>m.AuthModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m=>m.LoginModule),
        canActivate: [NoAuthGuard],
      },
      {
        path: "",
        pathMatch: 'full',
        redirectTo: 'auth'
      }
    ]
  },
  {
    // En caso de que no encuentre ninguna ruta valida
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
